var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('i',{class:_vm.icon,attrs:{"title":_vm.icon}}):_c('span',{class:'vb-'+_vm.icon})}
var staticRenderFns = []

export { render, staticRenderFns }